import React, { useState } from "react";
import PersonalInfoForm from "../component/PersonalInfoForm/PersonalInfoForm";
import ChangePasswordForm from "../component/ChangePasswordForm/ChangePasswordForm";
import CreateAdminModal from "../component/CreateAdminModal/CreateAdminModal";

function Profile() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="w-full  mx-auto mt-24 px-4">
      <div className="flex justify-between items-center mb-10">
        <h1 className="text-3xl font-bold text-gray-800">My Profile</h1>
        <button
          onClick={() => setShowModal(true)}
          className="bg-[#00428C] text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          Create Admin User
        </button>
      </div>
      <PersonalInfoForm />
      <ChangePasswordForm />

      {showModal && <CreateAdminModal onClose={() => setShowModal(false)} />}
    </div>
  );
}

export default Profile;
